import routerLink from '@/router-link'

export function getMenuItems() {
  return [
    { id: 'home', label: 'home', link: routerLink.topPage() },
    { id: 'vision', label: 'vision', link: routerLink.visionPage() },
    { id: 'news', label: 'news', link: routerLink.newsPage() },
    { id: 'article', label: 'article', link: routerLink.articlePage() },
    { id: 'service', label: 'service', link: '/', hash: '#service' },
    { id: 'event', label: 'event', link: routerLink.eventPage() },
    {
      id: 'specialist',
      label: 'specialist',
      link: routerLink.specialistPage(),
      // works/community/kaggleは旧デザインのレイアウトのため別タブで開く
      children: [
        { id: 'works', label: 'works', link: routerLink.worksPage(), newTab: true },
        { id: 'community', label: 'community', link: routerLink.communityPage(), newTab: true },
        { id: 'kaggle', label: 'kaggle', link: routerLink.kagglePage(), newTab: true }
      ]
    },
    // SP-only (see .header__nav-item--recruit in Navigation.vue): mirrors
    // the "0-1_s_menu.png" SP menu design, which adds a RECRUIT entry above
    // CONTACT with a Japanese subLabel, both set off by a divider line.
    { id: 'recruit', label: 'recruit', subLabel: '採用情報', link: routerLink.recruitPage() },
    { id: 'contact', label: 'contact', subLabel: '事業のお問い合わせ', link: routerLink.contactPage() }
  ]
}
